// Íconos «upload» y «file» del botón «Invitar en lote» y de la fila
// `ag-file` del drawer (handoff §3). Mismo trazo que components/icons.tsx
// (24/1.6, currentColor, aria-hidden); viven aquí porque icons.tsx es
// compartido y esta ronda no lo toca, como RefreshIcon. Si otra pantalla
// los necesita, se promueven a Icon.Upload / Icon.File.

type Props = { s?: number };

export function UploadIcon({ s = 14 }: Props) {
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M12 16V4M7 9l5-5 5 5" />
      <path d="M5 20h14" />
    </svg>
  );
}

export function FileIcon({ s = 18 }: Props) {
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" />
      <path d="M14 3v5h5" />
    </svg>
  );
}
